import { createSelector } from 'reselect'

export const getAdsWithPromoLoading = createSelector(
  (state) => state && state.ads && state.ads.adsWithPromos && state.ads.adsWithPromos.isLoading
    ? state.ads.adsWithPromos.isLoading : false,
  (isLoading) => isLoading
)
